import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';


class UserLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            authHandler: props.authHandler
        };
    }

    render() {
        var user = this.props.user;
        if (user != null) {
            return (
                <>
                <Grid container spacing={2}>
                    <Grid item>
                        <Avatar alt={user.name} src={user.image} />
                    </Grid>
                    <Grid item>
                        <Typography variant="h6">{user.name}</Typography>
                    </Grid>
                    <Grid item>
                    <Button onClick={this.state.authHandler} color="secondary">Logout</Button>
                    </Grid>
                </Grid>
                
                </>
            );
        } else {
            return (
                <>
                    <Button onClick={this.state.authHandler}>
                        Link with Youtube
                    </Button>
                </>
            );
        }

    }
}
export default UserLayout;


